import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent, TooltipDelay, TooltipDirective } from '@mode/capra';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, TooltipDirective],
  selector: 'mode-encoding-pill-base',
  templateUrl: './encoding-pill-base.component.html',
  styleUrls: ['./encoding-pill-base.component.scss'],
})
export class EncodingPillBaseComponent {
  @Input() title = '';
  @Input() displayName = '';
  @Input() isValid = false;
  @Input() isContinuous = false;
  @Input() isDiscrete = false;
  @Input() isAnalyticCalc = false;
  @Input() isDualAxis = false;
  @Input() isDualAxisRelative = false;
  @Input() isSharedAxis = false;
  @Input() isMultiple = false;
  @Input() hideDualAxisAffordances = false;
  @Input() secondaryIcon: string | undefined;
  @Input() secondaryIconClass: string | undefined;
  @Input() caretIcon = 'icon-invalid';

  @Input() tooltipContent: string | undefined;
  @Input() errorMessage: string | undefined;

  readonly tooltipInteractive = false;
  readonly tooltipDelay: TooltipDelay = 250;

  @Output() showMenu = new EventEmitter<MouseEvent>();

  onContextMenu($event: MouseEvent): void {
    this.showMenu.emit($event);
  }
}
